import { getFirebase } from 'firestorter';
import format from 'string-template';

import { firestorePaths, pathPlaceholder } from '../utils/paths';
import BaseDocument from './BaseDocument';

const WORKOUT_PICKS_CAP = 10;

class WorkoutPicks extends BaseDocument {
  get workoutIds() {
    return this.data.workoutIds || [];
  }

  get updatedAt() {
    return this.data.updatedAt;
  }

  get updatedBy() {
    return this.data.updatedBy;
  }

  async setWorkoutIds(workoutIds, editorId) {
    if (workoutIds.length > WORKOUT_PICKS_CAP) {
      throw new Error(`Cannot save more than ${WORKOUT_PICKS_CAP} workout picks`);
    }
    await this.updateFields({
      workoutIds,
      updatedAt: getFirebase().firestore.FieldValue.serverTimestamp(),
      updatedBy: editorId,
    });
  }

  static async getByCoachId(coachId) {
    const picksDoc = new WorkoutPicks(format(firestorePaths.WORKOUT_PICKS_DOC, {
      [pathPlaceholder.COACH_ID]: coachId,
    }));
    await picksDoc.init();
    return picksDoc;
  }
}

export { WORKOUT_PICKS_CAP };
export default WorkoutPicks;
